import { render, staticRenderFns } from "./Lists.vue?vue&type=template&id=628f9646&scoped=true&"
import script from "./Lists.vue?vue&type=script&lang=ts&"
export * from "./Lists.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628f9646",
  null
  
)

export default component.exports